import { ProductPageLayout } from '../components/ProductPageLayout';

export function NanoWorkflowPage() {
    return <ProductPageLayout productId="nano-workflow" />;
}
